import { Center, Heading, Text, VStack, HStack, Box } from "@chakra-ui/react";
import { GetStaticProps } from "next";
import { getCollections } from "../utils/shop_backend";
import React from "react";
import NextImage from "next/image";
import LotteImage from "../public/images/about-us/lotte.jpg";
import ChiaraImage from "../public/images/about-us/chiara.jpg";
import BothImage from "../public/images/about-us/both.jpg";
import { NextSeo } from "next-seo";

const hideMobile = ["none", null, "block"];
const hideDesktop = ["block", null, "none"];

// @ts-ignore collections prop used for header
const AboutUs = ({ collections }) => {
	return (
		<>
			<NextSeo title={"ABOUT US - Blickfang"} />
			<HStack justifyContent={'space-between'} alignItems={'flex-start'} gap={2}>
				<Box display={hideMobile} minWidth={"max-content"} overflow={"hidden"}>
					<NextImage priority={true} quality={70} alt={"Lotte"} src={LotteImage} placeholder={"blur"} width={"200"} style={{ height: "auto" }} />
				</Box>
				<Box display={hideDesktop} minWidth={"max-content"} overflow={"hidden"}>
					<NextImage priority={true} quality={70} alt={"Both"} src={BothImage} placeholder={"blur"} width={"140"} style={{ height: "auto" }} />
				</Box>

				<Center>
					<VStack padding={4} pt={15} maxWidth={"800px"}>
						<Heading pb={10}>ABOUT US</Heading>
						<Text>
							Wir sind Chiara und Lotte, Gründerinnen von Blickfang.
							<br />
							<br />
							Unser Modelabel entsandt im Herbst 2020 aus einer spontanen Idee, die mehr als Witz gedacht war. Doch aus einer Mischung aus Corona-Frustration und
							plötzlichem Schaffensdrang, gründeten wir mit 18 Jahren unser erstes Unternehmen.
							<br />
							<br />
							Uns war es wichtig, Produkte zu entwickeln, die dem Zeitgeist unserer Generation entsprechen. So war uns klar, dass graphische Designs und
							Nachhaltigkeit die Grundpfeiler unseres Unternehmens darstellen werden.
							<br />
							<br />
							Den Designprozess und das Drucken übernehmen wir selbst. Am Anfang steht eine Idee, welche wir zu einem fertigen Motiv entwickeln. Dieses bringen wir
							dann auf die Kleidung. Dafür haben wir das Verfahren des Siebdrucks gewählt, das als eines der nachhaltigsten gilt und drucken seitdem jedes
							Kleidungsstück von Hand. Es ist uns wichtig, unser Nachhaltigkeitskonzept stets zu hinterfragen und ständig weiterzuentwickeln.
							<br />
							<br />
							Seit diesem Jahr arbeiten wir daran, unsere Vision von vor 2 Jahren Schritt für Schritt zu professionalisieren. Gerade bauen wir unsere eigene kleine
							Siebdruckwerkstatt in einem rümpeligen Keller in Potsdam auf.
							<br />
							<br />
							Wir freuen uns auf alles, was kommt. Seid dabei!
						</Text>
					</VStack>
				</Center>

				<Box display={hideMobile} minWidth={"max-content"} overflow={"hidden"}>
					<NextImage priority={true} quality={70} alt={"Chiara"} src={ChiaraImage} placeholder={"blur"} width={"200"} style={{ height: "auto" }} />
				</Box>
			</HStack>
		</>
	);
};

export default AboutUs;

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {
			collections: await getCollections(),
		},
		revalidate: 60,
	};
};
